import { customerServiceOrganizationsEntryPoint } from '@jira/spa-apps__customer-service-organizations/src/customerServiceOrganizationsEntryPoint.entrypoint.tsx';
import { AsyncCustomersNav } from '@jira/navigation-apps__horizontal-nav-csm-customers/src/index.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { customerServiceManagementCrmImportModuleResource } from '@jira/customer-service__forge-extensions/src/crm-import/customerServiceManagementCrmImportModuleResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { customerServiceOrganizationsRoute } from '@jira/router-routes__customer-services-customers-routes/src/customerServiceOrganizationsRoute.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceOrganizationsPageEntryPoint = createPageEntryPoint({
	main: customerServiceOrganizationsEntryPoint,
});

export const customerServiceOrganizationsRouteEntry: Route = createEntry(
	customerServiceOrganizationsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.organizations',
		layout: globalLayout,
		navigation: {
			horizontal: AsyncCustomersNav,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return customerServiceOrganizationsPageEntryPoint;
		},
		resources: [
			...getNavigationResources(),
			l1CustomersProjectProviderResource,
			csmCustomerContextTenantMigratedStatusResource,
			customerServiceManagementCrmImportModuleResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
